import { Component, OnInit } from '@angular/core';
import { SemCallsV5Component } from '../sem-calls-v5/sem-calls-v5.component';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import * as _ from 'underscore';
import * as Highcharts from 'highcharts';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';

@Component({
	selector: 'app-sem-calls-r11',
	templateUrl: './sem-calls-r11.component.html',
	styleUrls: ['./sem-calls-r11.component.css']
})
export class SemCallsR11Component extends SemCallsV5Component implements OnInit {
	public dateRange: string = '';
	public defaultCount: number = 12;
	public isR9: boolean;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
	}

	ngOnInit(): void {
		this.isR9 = this.analyticsDataModel.config.version == 'R9' ? true : false;
		super.ngOnInit();
	}

	//filter answered calls
	filterChange(value: any) {
		this.selectedValue = value;
		super.filterChange(value);
	}

	protected getSeriesData(graphData: any, minCallDurationFilter: any, maxCallDurationFilter: any) {
		// data range
		this.dateRange =
			this.analyticsDataModel.startDate.format('MM/DD/YY') + ' - ' + this.analyticsDataModel.endDate.format('MM/DD/YY');
		//creating graph data with tooltip for both series
		let answeredSeriesData = [];
		let missedSeriesData = [];
		for (let i = 0; i < graphData.length; i++) {
			// answered calls
			if (graphData[i].answeredCalls > 0) {
				let time = graphData[i].time.split(':');
				time = (Number(time[0]) * 3600 + Number(time[1]) * 60 + Number(time[2])) * 1000;
				let callDurationsTooltip = graphData[i].callDurations.split(',').filter((value: any) => {
					return (
						(minCallDurationFilter == false || value > minCallDurationFilter) &&
						(maxCallDurationFilter == false || value <= maxCallDurationFilter)
					);
				});

				if (callDurationsTooltip.length > 0 && !this.isR9) {
					let plural = callDurationsTooltip.length > 1 ? 's' : '';
					callDurationsTooltip = callDurationsTooltip
						.map((duration: any, index: number) => {
							return (
								'<span class="text-left">Duration' +
								(plural ? ' ' + (index + 1) : '') +
								':</span>' +
								'<span class="text-right">' +
								Highcharts.dateFormat('%H:%M:%S', duration * 1000) +
								'</span><br/>'
							);
						})
						.join('');
					const tooltip =
						graphData[i].answeredCalls +
						' Call' +
						plural +
						' - ' +
						Highcharts.dateFormat('%l:%M:%S %p', time) +
						'<br/><br/>' +
						callDurationsTooltip;
					answeredSeriesData.push([graphData[i].dateObj * 1000, time, tooltip]);
				} else if (callDurationsTooltip.length > 0 && this.isR9) {
					let plural = callDurationsTooltip.length > 1 ? 's' : '';
					callDurationsTooltip = callDurationsTooltip
						.map((duration: any, index: number) => {
							return (
								'<span class="text-left">Call Duration' +
								(plural ? ' ' + (index + 1) : '') +
								':</span>' +
								'<span class="text-right">' +
								Highcharts.dateFormat('%H:%M:%S', duration * 1000) +
								'</span><br/>'
							);
						})
						.join('');
					const tooltip =
						'<span class="time">' +
						Highcharts.dateFormat('%l:%M:%S %p', time) +
						'</span><span class="calls">' +
						graphData[i].answeredCalls +
						' ' +
						'Answered Call' +
						plural +
						'</span>' +
						callDurationsTooltip;
					answeredSeriesData.push([graphData[i].dateObj * 1000, time, tooltip]);
				}
			}
			// missed Calls
			if (graphData[i].missedCalls > 0 && !this.isR9) {
				let time = graphData[i].time.split(':');
				time = (Number(time[0]) * 3600 + Number(time[1]) * 60 + Number(time[2])) * 1000;
				let plural = graphData[i].missedCalls > 1 ? 's' : '';
				const tooltip =
					graphData[i].missedCalls + ' Call' + plural + ' - ' + Highcharts.dateFormat('%l:%M:%S %p', time);
				missedSeriesData.push([graphData[i].dateObj * 1000, time, tooltip]);
			} else if (graphData[i].missedCalls > 0 && this.isR9) {
				let time = graphData[i].time.split(':');
				time = (Number(time[0]) * 3600 + Number(time[1]) * 60 + Number(time[2])) * 1000;
				let plural = graphData[i].missedCalls > 1 ? 's' : '';
				const tooltip =
					'<span class="time">' +
					Highcharts.dateFormat('%l:%M:%S %p', time) +
					'</span><span class="calls">' +
					graphData[i].missedCalls +
					' ' +
					'Missed Call' +
					plural +
					'</span>';
				missedSeriesData.push([graphData[i].dateObj * 1000, time, tooltip]);
			}
		}

		return { answeredCalls: answeredSeriesData, missedCalls: missedSeriesData };
	}

	//function to get tooltipconfig
	getToolTipConfig() {
		let customTooltip = this.chartConfig.graphConfig.customTooltip ? this.chartConfig.graphConfig.customTooltip : false;
		if (this.isR9) {
			return {
				useHTML: true,
				borderColor: customTooltip && customTooltip.borderColor ? customTooltip.borderColor : '#fff',
				borderWidth: customTooltip && customTooltip.borderWidth ? customTooltip.borderWidth : 0,
				borderRadius:
					customTooltip && (customTooltip.borderRadius || customTooltip.borderRadius == 0)
						? customTooltip.borderRadius
						: 5,
				backgroundColor: customTooltip && customTooltip.backgroundColor ? customTooltip.backgroundColor : '#fff',
				style: {
					textAlign:
						customTooltip && customTooltip.style && customTooltip.style.textAlign
							? customTooltip.style.textAlign
							: 'center'
				},
				formatter: function () {
					return '<span class="date">' + Highcharts.dateFormat('%m/%d/%y', this.x) + '</span>' + this.point.tooltip;
				}
			};
		} else {
			return {
				useHTML: true,
				borderColor: customTooltip && customTooltip.borderColor ? customTooltip.borderColor : '#fff',
				borderWidth: customTooltip && customTooltip.borderWidth ? customTooltip.borderWidth : 0,
				borderRadius:
					customTooltip && (customTooltip.borderRadius || customTooltip.borderRadius == 0)
						? customTooltip.borderRadius
						: 5,
				backgroundColor: customTooltip && customTooltip.backgroundColor ? customTooltip.backgroundColor : '#fff',
				style: {
					textAlign:
						customTooltip && customTooltip.style && customTooltip.style.textAlign
							? customTooltip.style.textAlign
							: 'center'
				},
				formatter: function () {
					return Highcharts.dateFormat('%m/%d/%y', this.x) + '<br/>' + this.point.tooltip;
				}
			};
		}
	}
}
